import React from 'react';
import logoLb from '/src/assets/logo-lb.svg';
import { useTranslation } from '@/hooks/useTranslation';

interface LogoProps {
  src?: string;
  alt?: string;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ src = logoLb, alt, className = '' }) => {
  const { t } = useTranslation();
  return <img src={src} alt={alt ?? t('common.logoAlt')} className={`h-8 w-auto ${className}`} />;
};

export default Logo;
